import React, { ComponentProps, forwardRef } from 'react';
import { OverflowMenuItem as CarbonOverflowMenuItem } from '@carbon/react';

type OverflowMenuItemProps = ComponentProps<typeof CarbonOverflowMenuItem>;

export const OverflowMenuItem = forwardRef<HTMLElement, OverflowMenuItemProps>(
  (props, ref) => <CarbonOverflowMenuItem {...props} ref={ref} />
);

OverflowMenuItem.displayName = 'OverflowMenuItem';
